import searchQuerySchema from '../routes/SearchPage/searchQuerySchema';
import { SearchFilters } from '../types/search';
import querystring from 'query-string';

const queryToSearchFilters = (query?: string): SearchFilters => {
  if (!query){
    return searchQuerySchema.cast({});
  }
  
  const parsedFilters = querystring.parse(query, { arrayFormat: 'comma' });

  return searchQuerySchema.cast(parsedFilters);
};

export default queryToSearchFilters;
